var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag-title-wrapper"},[_c('div',{staticClass:"real"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"bg-top",style:({borderBottomColor: _vm.theme})}),_c('div',{staticClass:"bg-bottom",style:({borderBottomColor: _vm.theme})})]),_c('div',{staticClass:"line",style:({background: _vm.theme})})])
}
var staticRenderFns = []

export { render, staticRenderFns }